// components/ArticleList.tsx
import React from 'react';
import Link from 'next/link';
import { Card } from '@mui/material';
import Image from 'next/image';
import { CategoriaObj } from '@/objects/Categorias';
import { TFunction } from 'next-i18next';
import Texto from '../../Texto';
import { primaryDark, white } from '@/constants/Colors';
import ImageCustom, { TypeLoading } from '../../ImageCustom';

interface Props {
  categoria: CategoriaObj;
  t: TFunction
}

const RowCategoria: React.FC<Props> = ({ categoria, t }) => {

  //alert(JSON.stringify(articles)) 
  return (
    <Link key={"categoria_" + categoria.categoriaString} href={categoria.link} title={t(categoria.title)} style={{ textDecoration: 'none' }}>
      <Card
        elevation={4}
        sx={{
          height: '100%',
          padding: 3,
          borderRadius: 3,
          backgroundColor: white,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
          }
        }}
      >
        <ImageCustom
          src={categoria.icono}
          alt={t(categoria.alt)}
          width={60}
          height={60}
          loading={TypeLoading.LAZY}
        />
        <Texto color={primaryDark} style={{ marginTop: "12px", fontWeight: 600, fontSize: "1rem", textAlign: 'center' }}>
          {t(categoria.titulo)}
        </Texto>
      </Card>
    </Link>
  );
};

export default RowCategoria;
